import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { IncidentRegelSetStatus } from '../models/IncidentRegelSetStatus';
import { RegelsService } from '../services/regels.service';

import { genericSortingAccessor } from '../shared.module';
import {
  UntypedFormBuilder,
  FormControl,
  UntypedFormGroup
} from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-incident-regel-set-status',
  templateUrl: './incident-regel-set-status.component.html',
  styleUrls: ['./beheer-regels.component.scss']
})
export class IncidentRegelSetStatusComponent {
  public zoekenNogLeeg = true;
  tekstResultaat = '';

  zoekenVanaf: Date;
  zoekenTot: Date;
  zoekVeld = '';

  zoekForm: UntypedFormGroup = this.fb.group({
    zoekTerm: [''],
    zoekenVanaf: [moment().subtract(5, 'day').toDate()],
    zoekenVanafTijd: [''],
    zoekenTot: [moment().toDate()],
    zoekenTotTijd: ['']
  });

  dataSourceIncidentRegelSetStatus =
    new MatTableDataSource<IncidentRegelSetStatus>();
  displayedColumnsIncidentRegelSetStatus: string[] = [
    'id',
    'regelSetId',
    'regelId',
    'regelSetActieId',
    'dbIncidentId',
    'incidentId',
    'incidentNummer',
    'waardeToegepasteRegels',
    'tijdstip',
    'status',
    'succesRegelMatch'
  ];

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private regelsSvc: RegelsService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {}

  public zoektermGewijzigd() {
    this.refreshDataSourceIncidentRegelSetStatus();
  }

  refreshDataSourceIncidentRegelSetStatus(): void {
    let nieuwezoekenVanaf: moment.Moment = moment(
      this.zoekForm.value.zoekenVanaf
    );
    let zoekenVanafTijd =
      this.zoekForm.value.zoekenVanafTijd &&
      this.zoekForm.value.zoekenVanafTijd.length > 0
        ? moment(this.zoekForm.value.zoekenVanafTijd, 'HH:mm')
        : moment('00:00', 'HH:mm');
    nieuwezoekenVanaf.hour(zoekenVanafTijd.hours());
    nieuwezoekenVanaf.minute(zoekenVanafTijd.minutes());

    let nieuwezoekenTot: moment.Moment = moment(this.zoekForm.value.zoekenTot);
    let zoekenTotTijd =
      this.zoekForm.value.zoekenTotTijd &&
      this.zoekForm.value.zoekenTotTijd.length > 0
        ? moment(this.zoekForm.value.zoekenTotTijd, 'HH:mm')
        : moment('23:59', 'HH:mm');
    nieuwezoekenTot.hour(zoekenTotTijd.hours());
    nieuwezoekenTot.minute(zoekenTotTijd.minutes());

    this.zoekVeld = this.zoekForm.value.zoekTerm;
    this.zoekenVanaf = nieuwezoekenVanaf.toDate();
    this.zoekenTot = nieuwezoekenTot.toDate();

    console.log(this.zoekVeld);
    console.log(this.zoekenVanaf);
    console.log(this.zoekenTot);

    if (this.zoekVeld) {
      this.regelsSvc
        .loadIncidentRegelSetStatusByIncidentNummer(
          this.zoekVeld,
          this.zoekenVanaf,
          this.zoekenTot
        )
        .subscribe((o) => {
          this.dataSourceIncidentRegelSetStatus.data = o;
          this.dataSourceIncidentRegelSetStatus.sort = this.sort;
          this.dataSourceIncidentRegelSetStatus.sortingDataAccessor =
            genericSortingAccessor;
          this.verwerkingZoekresultaat();
        });
    } else {
      this.regelsSvc
        .loadIncidentRegelSetStatus(this.zoekenVanaf, this.zoekenTot)
        .subscribe((o) => {
          this.dataSourceIncidentRegelSetStatus.data = o;
          this.dataSourceIncidentRegelSetStatus.sort = this.sort;
          this.dataSourceIncidentRegelSetStatus.sortingDataAccessor =
            genericSortingAccessor;
          this.verwerkingZoekresultaat();
        });
    }
  }

  verwerkingZoekresultaat() {
    let incidentRegelSetStatussen: IncidentRegelSetStatus[] = [];

    if (this.dataSourceIncidentRegelSetStatus.data) {
      incidentRegelSetStatussen = this.dataSourceIncidentRegelSetStatus.data;
    }
    switch (incidentRegelSetStatussen.length) {
      case 0: {
        this.tekstResultaat = 'geen status gevonden.';
        this.zoekenNogLeeg = true;
        break;
      }
      case 1: {
        this.tekstResultaat = 'eén status gevonden.';
        this.zoekenNogLeeg = false;
        break;
      }
      default: {
        this.tekstResultaat = `${incidentRegelSetStatussen.length} Statussen gevonden.`;
        this.zoekenNogLeeg = false;
        break;
      }
    }
  }
}
